import React from "react";
import FileHelper from "@utils/file-helper";
import {SelectedFileMeta} from "../../models/types/convert-document-ai-modal.types";
import {MAX_FILES, MAX_TOTAL_SIZE_MB} from "../../constants/convert-document-ai-modal";
import SelectedFileItem from "./selected-file-item";

interface FileListProps {
    files: SelectedFileMeta[];
    totalSize: number;
    disabled: boolean;
    onRemove: (index: number) => void;
}

const FileList: React.FC<FileListProps> = (props: FileListProps) => {
    const {files, totalSize, disabled, onRemove} = props;

    if (files.length === 0) return null;

    return (
        <>
            <div className="space-y-3">
                {files.map((file, index) => (
                    <SelectedFileItem
                        key={`${file.name}-${file.size}-${index}`}
                        file={file}
                        disabled={disabled}
                        onRemove={() => onRemove(index)}
                    />
                ))}
            </div>
            <p className="text-xs text-on-surface/60 mt-2">
                {files.length} z {MAX_FILES} plików
                • {FileHelper.getReadableFileSize(totalSize)} z {MAX_TOTAL_SIZE_MB} MB
            </p>
        </>
    );
};

export default FileList;
